
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetEventService {

  constructor(private http: HttpClient) {}

  async GetEvent() {
    try { 
      let response = await this.http
        .get(`${appApiResources.getEvent}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}